module.exports = __webpack_public_path__ + "img/icons8-one-page-58.b6514f5e.svg";